// erp

import request from '@/utils/request'

// 获取平台列表
export function PlatformList(data) {
  return request({
    url: 'OakCommon/PlatformList',
    method: 'get',
    params: data
  })
}
// 根据id获取子平台列表
export function SubPlatformList(data) {
  return request({
    url: 'OakCommon/SubPlatformList',
    method: 'get',
    params: data
  })
}

// 获取物流类别列表
export function LogisticsTypeList(data) {
  return request({
    url: 'OakCommon/LogisticsTypeList',
    method: 'get',
    params: data
  })
}

// 获取省份
export function ProvinceList(data) {
  return request({
    url: 'OakCommon/ProvinceList',
    method: 'get',
    params: data
  })
}

// 获取市
export function CityList(data) {
  return request({
    url: 'OakCommon/CityList',
    method: 'get',
    params: data
  })
}
// 获取区
export function DistrictList(data) {
  return request({
    url: 'OakCommon/DistrictList',
    method: 'get',
    params: data
  })
}
// 获取物流列表
export function LogisticsList(data) {
  return request({
    url: 'OakCommon/LogisticsList',
    method: 'get',
    params: data
  })
}
// 获取仓库列表
export function WarehouseList(data) {
  return request({
    url: 'OakCommon/WarehouseList',
    method: 'get',
    params: data
  })
}

//获取列
export function GetUserListField(data) {
  return request({
    url: 'ListFieldConf/GetUserListField',
    method: 'get',
    params: data
  })
}
//保存列
export function SaveUserListFieldConf(data) {
  return request({
    url: 'ListFieldConf/SaveUserListFieldConf',
    method: 'post',
    data: data
  })
}

// 恢复默认列
export function RecoveryDefaultListFieldConf(data) {
  return request({
    url: 'ListFieldConf/RecoveryDefaultListFieldConf',
    method: 'post',
    data: data
  })
}
// 调整列宽
export function EditUserListFieldWidthConf(data) {
  return request({
    url: 'ListFieldConf/EditUserListFieldWidthConf',
    method: 'post',
    data: data
  })
}
// 设为默认
export function SetDefaultListFieldConf(data) {
  return request({
    url: 'ListFieldConf/SetDefaultListFieldConf',
    method: 'post',
    data: data
  })
}
// getbase
export function GetBaseList(data) {
  return request({
    url: 'OakCommon/GetBaseList',
    method: 'get',
    params: data
  })
}
// 获取分类列表
export function GetClassList(data) {
  return request({
    url: 'OakCommon/GetClassList',
    method: 'get',
    params: data
  })
}
// 获取品牌列表
export function GetBrandList(data) {
  return request({
    url: 'OakCommon/GetBrandList',
    method: 'get',
    params: data
  })
}
// 获取店铺list
export function GetShopList(data) {
  return request({
    url: 'OakCommon/GetShopList',
    method: 'get',
    params: data
  })
}